import React from 'react';
import { styled } from '@mui/material/styles';

interface KitCardFooterProps {
  className?: string;
  children?: React.ReactNode;
  plain?: boolean;
  profile?: boolean;
  pricing?: boolean;
  testimonial?: boolean;
  [key: string]: unknown;
}

interface KitCardFooterStyleProps {
  plain?: boolean;
  profile?: boolean;
  pricing?: boolean;
  testimonial?: boolean;
}

export default function CardFooter(props: KitCardFooterProps) {
  const { className, children, plain, profile, pricing, testimonial, ...rest } =
    props;
  return (
    <Container
      className={className}
      {...rest}
      plain={plain}
      profile={profile}
      pricing={pricing}
      testimonial={testimonial}
    >
      {children}
    </Container>
  );
}

const Container = styled('div', {
  shouldForwardProp: (prop) =>
    !['plain', 'profile', 'pricing', 'testimonial'].includes(prop as string),
})<KitCardFooterStyleProps>(
  ({
    theme: _theme
  }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    padding: '0.9375rem 1.875rem',
    paddingTop: '0',
    variants: [{
      props: (
        {
          plain
        }
      ) => plain,
      style: {
        paddingLeft: '5px',
        paddingRight: '5px',
        backgroundColor: 'transparent',
      }
    }, {
      props: (
        {
          profile
        }
      ) => profile,
      style: {
        marginTop: '-15px',
      }
    }, {
      props: (
        {
          pricing
        }
      ) => pricing,
      style: { zIndex: '2' }
    }, {
      props: (
        {
          testimonial
        }
      ) => testimonial,
      style: {
        display: 'block',
      }
    }]
  }),
);
